import ClimaEmployeeCheckList from "../../components/Clima/ClimaEmployeeCheckList";
import Campaña from "./campaña";
// import CampañaResponsable from "./responsable-jefe/campañaResponsable";
import Categoria from "./admin/category";
import DashboardClima from "./responsable-jefe/dashboardClima";
import Encuesta from "./encuestado/encuestaUsuario";
import PlantillasVisualización from "./admin/formularios/encuesta";
import Plantillas from "./admin/formularios/Plantillas";
import PlantillasCreación from "./admin/formularios/PlantillasCreación";
import Mediciones from "./admin/measurements";
import ReporteClimaLaboral from "./responsable-jefe/reporteClimaLaboral";
import Segmento from "./admin/segment";
import SettingsClimate from "./admin/SettingsClimate";
import TipoPregunta from "./admin/TipoPregunta";
import Herramienta from "./admin/tool";
import ClimaLog from "./admin/clima.log";

const climaRoutes = [
  {
    type: "private",
    path: "/categorias",
    roles: ["administrador"],
    component: Categoria,
    exact: true,
  },
  {
    type: "private",
    path: "/mediciones",
    roles: ["administrador"],
    component: Mediciones,
    exact: true,
  },
  {
    type: "private",
    path: "/herramienta",
    roles: ["administrador"],
    component: Herramienta,
    exact: true,
  },
  {
    type: "private",
    path: "/TipoPregunta",
    roles: ["administrador"],
    component: TipoPregunta,
    exact: true,
  },
  {
    type: "private",
    path: "/configuración-clima",
    roles: ["administrador", "responsable"],
    component: SettingsClimate,
    exact: true,
  },
  {
    type: "private",
    path: "/campaña",
    roles: ["administrador"],
    component: Campaña,
    exact: true,
  },
  {
    type: "private",
    path: "/campañas/responsable/:userName",
    roles: ["responsable", "administrador"],
    // component: CampañaResponsable,
    component: Campaña,
    exact: true,
  },
  {
    type: "private",
    path: "/cuestionarios",
    roles: ["administrador", "responsable"],
    component: Plantillas,
    exact: true,
  },
  {
    type: "private",
    path: "/cuestionario/:id/:Name",
    roles: ["administrador", "responsable"],
    component: PlantillasCreación,
    exact: true,
  },
  {
    type: "private",
    path: "/segmentación",
    roles: ["administrador", "responsable"],
    component: Segmento,
    exact: true,
  },
  {
    type: "private",
    // path: "/Dashboard-Clima",
    path: "/Indicador-Clima-Laboral",
    roles: ["administrador", "responsable"],
    component: DashboardClima,
    exact: true,
  },
  {
    type: "private",
    // path: "/Reporte-Clima-Laboral",
    path: "/Tablero-Clima-Laboral",
    roles: ["administrador", "responsable"],
    component: ReporteClimaLaboral,
    exact: true,
  },
  {
    type: "private",
    path: "/encuesta/vista-previa/:id/:Name",
    roles: ["administrador", "responsable"],
    component: PlantillasVisualización,
    exact: true,
  },
  {
    type: "private",
    path: "/encuestas/:idCuestionario/:idEncuesta/:idCamp",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "responsable",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: Encuesta,
    exact: true,
  },
  {
    type: "private",
    path: "/clima-laboral/encuestas-pendientes/:id/:type",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "responsable",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: ClimaEmployeeCheckList,
    exact: true,
  },
  {
    type: "private",
    path: "/clima-laboral/log",
    roles: ["responsable", "administrador"],
    component: ClimaLog,
    exact: true,
  },
];

export default climaRoutes;
